import { Outlet } from 'react-router-dom';

export const EmployeeOutlet = () => <Outlet />;
